// extracted by mini-css-extract-plugin
export default {"container":"Home_container__ab2eM","title":"Home_title__ay21K","grid":"Home_grid__1yU1W","card":"Home_card__IEHNS","icon":"Home_icon__KvMkb"};